import { useTranslation } from "react-i18next";

import React, { useMemo } from "react";
import getCancellationPorlicyText from "utils/get_cancellation_policy_text";
import getPaymentPolicyText from "utils/get_payment_policy_text";
import styles from "./policy_data.module.css";
import BookingDate from "../Booking_date/booking_date";
export default function PolicyData({
  ratePlan,
  checkInDate,
  checkOutDate,
  property,
  allowedCards = [],
}) {
  const { t } = useTranslation();
  const { cancellationPolicy } = ratePlan;
  const paymentPolicyText = useMemo(
    () => getPaymentPolicyText(cancellationPolicy),
    [cancellationPolicy],
  );

  const cancellationPolicyText = useMemo(
    () => getCancellationPorlicyText(cancellationPolicy),
    [cancellationPolicy],
  );

  return (
    <div className={styles.container}>
      {paymentPolicyText && (
        <div className={styles.container}>
          <h3 className={styles.title}>{t("rates_table:prepayment")} Policy </h3>
          <p className={styles.desc}>{paymentPolicyText}</p>
        </div>
      )}
      {allowedCards?.length > 0 && (
        <div className={styles.container}>
          <h3 className={styles.title}>Accepted Cards</h3>
          {allowedCards?.map((card) => (
            <ul>
              <li className={styles.desc}>{card?.name}</li>
            </ul>
          ))}
        </div>
      )}

      {cancellationPolicyText && (
        <div className={styles.container}>
          <h3 className={styles.title}>{t("rates_table:cancellation")} Policy</h3>
          <p className={styles.desc}>{cancellationPolicyText}</p>
        </div>
      )}

      <h3 className={styles.title}>Check-in Policy</h3>
      <div className="mt-3">
        <BookingDate date={checkInDate} type="checkin" />
        <BookingDate date={checkOutDate} type="checkout" />
      </div>
    </div>
  );
}
